import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'prMath',
    standalone: false
})
export class PrMathPipe implements PipeTransform {
  /**
   *
   * @param value
   *
   * @param method : Math method
   *
   * @returns {number}
   */
  transform(value: number, method: string): number {
    try {
      return Math[method](value);
    } catch (err) {
      throw Error(err);
    }
  }
}
